import { observer } from 'mobx-react';
import { FC, ReactElement, useEffect } from 'react';
import { ProfilesScrollableList, TProfile } from '~/view/containers/ProfilesList';
import { dispatchingRulesStore } from '~/view/screens/DeliveryManagementScreen/screens/DispatchingRulesScreen/stores/dispatchingRulesStore';

export const DispatchingRulesProfilesList: FC = observer((): ReactElement => {
  useEffect(() => {
    dispatchingRulesStore.getProfiles();
  }, []);

  const onUpdateProfileName = async (profile: TProfile) => {
    return await dispatchingRulesStore.updateProfile({ name: { id: profile.id, value: profile.name } });
  };

  return (
    <ProfilesScrollableList
      loading={dispatchingRulesStore.loading}
      profiles={dispatchingRulesStore.profiles}
      onAddProfile={dispatchingRulesStore.addProfile}
      selectProfile={dispatchingRulesStore.selectProfile}
      onUpdateName={onUpdateProfileName}
      selectedProfileId={dispatchingRulesStore.selectedProfile?.id}
    />
  );
});
